import * as React from 'react';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import { PlayerState } from '../types/index.esm.js';
import { analyticsTracker } from '../../utils/analytics-tracker/index.esm.js';

/* istanbul ignore file */
const useVideoHook = analytics => {
  const [playerError, setPlayerError] = React.useState({
    status: false,
    data: 0
  });
  const [isPlayerReady, setIsPlayerReady] = React.useState(false);
  const [playerState, setPlayerState] = React.useState(PlayerState.UNSTARTED);
  const [player, setPlayer] = React.useState();
  const onPlayerError = event => {
    setPlayerError({
      status: true,
      data: event.data
    });
    if (analytics) {
      analyticsTracker(analytics, 'playerError', event);
    }
  };
  const onPlayerReady = event => {
    setIsPlayerReady(true);
    setPlayerState(event.target.getPlayerState());
  };
  const onClickPlay = () => {
    if (!player) console.warn('Play noop; no YT player found');
    player?.playVideo();
    if (analytics) {
      analyticsTracker(analytics, 'playVideo', '');
    }
  };
  const onClickPause = () => {
    if (!player) console.warn('Pause noop; No YT player found');
    player?.pauseVideo();
    if (analytics) {
      analyticsTracker(analytics, 'pauseVideo', '');
    }
  };
  const onPlayerStateChange = event => {
    const newState = event.data;
    setPlayerState(newState);
    if (newState === PlayerState.PLAYING) {
      onClickPlay();
    } else if (newState === PlayerState.PAUSED) {
      onClickPause();
    }
  };
  return {
    playerError,
    onPlayerError,
    isPlayerReady,
    onPlayerReady,
    playerState,
    onPlayerStateChange,
    player,
    setPlayer,
    onClickPlay,
    onClickPause
  };
};
export { useVideoHook };